<template>
  <ListCostAllocator
    mode="consumer"
    :cost-centre="$route.params.id"
    :project-id="$route.params.project_id"
  ></ListCostAllocator>
</template>

<script>
import ListCostAllocator from "../cost-allocators/ListCostAllocator";
export default {
  name: "ConsumingCostCentre",
  components: {
    ListCostAllocator
  }
};
</script>

<style scoped></style>
